// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81vhk{font:var(--ds-font-heading-xxsmall,normal 600 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}\n._syaz1tmw{color:var(--ds-text-danger,#ae2e24)}", ""]);
// Exports
module.exports = exports;
